function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute("role", "button");
  summary.setAttribute(
    "aria-expanded",
    summary.parentNode.hasAttribute("open")
  );

  if (summary.nextElementSibling.getAttribute("id")) {
    summary.setAttribute("aria-controls", summary.nextElementSibling.id);
  }

  summary.addEventListener("click", (event) => {
    event.currentTarget.setAttribute(
      "aria-expanded",
      !event.currentTarget.closest("details").hasAttribute("open")
    );
  });

  if (summary.closest("header-drawer")) return;
  summary.parentElement.addEventListener("keyup", onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener("keydown", trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener("keydown", trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== "TAB") return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener("focusout", trapFocusHandlers.focusout);
  document.addEventListener("focusin", trapFocusHandlers.focusin);

  elementToFocus.focus();

  if (
    elementToFocus.tagName === "INPUT" &&
    ["search", "text", "email", "url"].includes(elementToFocus.type) &&
    elementToFocus.value
  ) {
    elementToFocus.setSelectionRange(0, elementToFocus.value.length);
  }
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(":focus-visible");
} catch (e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = [
    "ARROWUP",
    "ARROWDOWN",
    "ARROWLEFT",
    "ARROWRIGHT",
    "TAB",
    "ENTER",
    "SPACE",
    "ESCAPE",
    "HOME",
    "END",
    "PAGEUP",
    "PAGEDOWN",
  ];
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener("keydown", (event) => {
    if (navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener("mousedown", (event) => {
    mouseClick = true;
  });

  window.addEventListener(
    "focus",
    () => {
      if (currentFocusedElement)
        currentFocusedElement.classList.remove("focused");

      if (mouseClick) return;

      currentFocusedElement = document.activeElement;
      currentFocusedElement.classList.add("focused");
    },
    true
  );
}

function pauseAllMedia() {
  document.querySelectorAll(".js-youtube").forEach((video) => {
    video.contentWindow.postMessage(
      '{"event":"command","func":"' + "pauseVideo" + '","args":""}',
      "*"
    );
  });
  document.querySelectorAll(".js-vimeo").forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', "*");
  });
  document.querySelectorAll("video").forEach((video) => video.pause());
  document.querySelectorAll("product-model").forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener("focusin", trapFocusHandlers.focusin);
  document.removeEventListener("focusout", trapFocusHandlers.focusout);
  document.removeEventListener("keydown", trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== "ESCAPE") return;

  const openDetailsElement = event.target.closest("details[open]");
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector("summary");
  openDetailsElement.removeAttribute("open");
  summaryElement.setAttribute("aria-expanded", false);
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector("input");
    this.changeEvent = new Event("change", { bubbles: true });

    this.input.addEventListener("change", this.onInputChange.bind(this));
    this.querySelectorAll("button").forEach((button) =>
      button.addEventListener("click", this.onButtonClick.bind(this))
    );
  }

  quantityUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.validateQtyRules();
    this.quantityUpdateUnsubscriber = subscribe(
      PUB_SUB_EVENTS.quantityUpdate,
      this.validateQtyRules.bind(this)
    );
  }

  disconnectedCallback() {
    if (this.quantityUpdateUnsubscriber) {
      this.quantityUpdateUnsubscriber();
    }
  }

  onInputChange(event) {
    this.validateQtyRules();
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    if (this.input.classList.contains("cart-input")) {
      let dataMaxValue = parseInt(this.input.getAttribute("data-max"));
      let dataStep = parseInt(this.input.getAttribute("step"));
      let newValue = parseInt(previousValue) + dataStep;
      if (
        newValue > dataMaxValue &&
        this.input.classList.contains("cart-buy-now") &&
        event.target.name === "plus"
      ) {
        event.preventDefault();
        const notificationText = `Sorry, we don't have enough in stock for that many Buy Now purchases. We currently have ${dataMaxValue} available. Please select Pre-order and try again, or contact us to discuss your options.`;
        alert(notificationText);
      } else {
        event.target.name === "plus"
          ? this.input.stepUp()
          : this.input.stepDown();
        if (previousValue !== this.input.value)
          this.input.dispatchEvent(this.changeEvent);
      }
    } else {
      event.target.name === "plus"
        ? this.input.stepUp()
        : this.input.stepDown();
      if (previousValue !== this.input.value)
        this.input.dispatchEvent(this.changeEvent);
    }
  }

  validateQtyRules() {
    let value = parseInt(this.input.value);

    if (this.input.min) {
      const min = parseInt(this.input.min);
      const buttonMinus = this.querySelector(".quantity__button[name='minus']");
      //buttonMinus.classList.toggle('disabled', value <= min);
    }
    if (this.input.max) {
      const max = parseInt(this.input.max);
      const buttonPlus = this.querySelector(".quantity__button[name='plus']");
      //buttonPlus.classList.toggle('disabled', value >= max);
    }
    let data_min = this.querySelector(".quantity__input").getAttribute("data-min");
    const priceElement = document.querySelector(".cta-price");
    if (!priceElement) return;

    const anchorPrice = document.querySelector(".sticky-add-to-cart-wrap .selected-variantprice");
    const zipPrice = document.querySelector(".zip-container strong");
    const zipPriceAll = document.querySelectorAll(".zip-container strong");
    const originalPriceString = priceElement.getAttribute("data-single-price").trim();

    const result =
      "$" +
      (value * parseFloat(originalPriceString.replace(/[,$]/g, "")))
        .toLocaleString(undefined, {
          minimumFractionDigits: 0,
          maximumFractionDigits: 2,
        })
        .replace(/(\.\d$)/, "$10");
    priceElement.innerText = result;
    if (data_min == "1") {
      anchorPrice.innerText =
        "$" +
        (value * parseFloat(originalPriceString.replace(/[,$]/g, "")))
          .toLocaleString(undefined, {
            minimumFractionDigits: 0,
            maximumFractionDigits: 2,
          })
          .replace(/(\.\d$)/, "$10");
    } else {
      anchorPrice.innerText =
        "$" +
        parseFloat(originalPriceString.replace(/[,$]/g, ""))
          .toLocaleString(undefined, {
            minimumFractionDigits: 0,
            maximumFractionDigits: 2,
          })
          .replace(/(\.\d$)/, "$10");
    }
    if (zipPrice != null) {
      zipPriceAll.forEach((strong) => {
        strong.innerText =
          "$" +
          (0.1666666 * parseFloat(originalPriceString.replace(/[,$]/g, "")))
            .toLocaleString(undefined, {
              minimumFractionDigits: 0,
              maximumFractionDigits: 2,
            })
            .replace(/(\.\d$)/, "$10") +
          "/mth for 6 months";
      });
    }
  }
}

customElements.define("quantity-input", QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function fetchConfig(type = "json") {
  return {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: `application/${type}`,
    },
  };
}

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == "undefined") {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : target.attachEvent("on" + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options["method"] || "post";
  var params = options["parameters"] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for (var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (
  country_domid,
  province_domid,
  options
) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(
    options["hideElement"] || province_domid
  );

  Shopify.addListener(
    this.countryEl,
    "change",
    Shopify.bind(this.countryHandler, this)
  );

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute("data-default");
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute("data-default");
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute("data-provinces");
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = "none";
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement("option");
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement("option");
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  },
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector("details");

    this.addEventListener("keyup", this.onKeyUp.bind(this));
    this.addEventListener("focusout", this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll("summary").forEach((summary) =>
      summary.addEventListener("click", this.onSummaryClick.bind(this))
    );
    this.querySelectorAll("button:not(.localization-selector)").forEach(
      (button) =>
        button.addEventListener("click", this.onCloseButtonClick.bind(this))
    );
  }

  onKeyUp(event) {
    if (event.code.toUpperCase() !== "ESCAPE") return;

    const openDetailsElement = event.target.closest("details[open]");
    if (!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle
      ? this.closeMenuDrawer(
          event,
          this.mainDetailsToggle.querySelector("summary")
        )
      : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const parentMenuElement = detailsElement.closest(".has-submenu");
    const isOpen = detailsElement.hasAttribute("open");
    const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");

    function addTrapFocus() {
      trapFocus(
        summaryElement.nextElementSibling,
        detailsElement.querySelector("button")
      );
      summaryElement.nextElementSibling.removeEventListener(
        "transitionend",
        addTrapFocus
      );
    }

    if (detailsElement === this.mainDetailsToggle) {
      if (isOpen) event.preventDefault();
      isOpen
        ? this.closeMenuDrawer(event, summaryElement)
        : this.openMenuDrawer(summaryElement);

      if (window.matchMedia("(max-width: 990px)")) {
        document.documentElement.style.setProperty(
          "--viewport-height",
          `${window.innerHeight}px`
        );
      }
    } else {
      setTimeout(() => {
        detailsElement.classList.add("menu-opening");
        summaryElement.setAttribute("aria-expanded", true);
        parentMenuElement && parentMenuElement.classList.add("submenu-open");
        !reducedMotion || reducedMotion.matches
          ? addTrapFocus()
          : summaryElement.nextElementSibling.addEventListener(
              "transitionend",
              addTrapFocus
            );
      }, 100);
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add("menu-opening");
    });
    summaryElement.setAttribute("aria-expanded", true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event === undefined) return;

    this.mainDetailsToggle.classList.remove("menu-opening");
    this.mainDetailsToggle.querySelectorAll("details").forEach((details) => {
      details.removeAttribute("open");
      details.classList.remove("menu-opening");
    });
    this.mainDetailsToggle
      .querySelectorAll(".submenu-open")
      .forEach((submenu) => {
        submenu.classList.remove("submenu-open");
      });
    document.body.classList.remove(
      `overflow-hidden-${this.dataset.breakpoint}`
    );
    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);
  }

  onFocusOut() {
    setTimeout(() => {
      if (
        this.mainDetailsToggle.hasAttribute("open") &&
        !this.mainDetailsToggle.contains(document.activeElement)
      )
        this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest("details");
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    const parentMenuElement = detailsElement.closest(".submenu-open");
    parentMenuElement && parentMenuElement.classList.remove("submenu-open");
    detailsElement.classList.remove("menu-opening");
    detailsElement
      .querySelector("summary")
      .setAttribute("aria-expanded", false);
    removeTrapFocus(detailsElement.querySelector("summary"));
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute("open");
        if (detailsElement.closest("details[open]")) {
          trapFocus(
            detailsElement.closest("details[open]"),
            detailsElement.querySelector("summary")
          );
        }
      }
    };

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define("menu-drawer", MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header = this.header || document.querySelector(".section-header");
    this.borderOffset =
      this.borderOffset ||
      this.closest(".header-wrapper").classList.contains(
        "header-wrapper--border-bottom"
      )
        ? 1
        : 0;
    document.documentElement.style.setProperty(
      "--header-bottom-position",
      `${parseInt(
        this.header.getBoundingClientRect().bottom - this.borderOffset
      )}px`
    );
    this.header.classList.add("menu-open");

    setTimeout(() => {
      this.mainDetailsToggle.classList.add("menu-opening");
    });

    summaryElement.setAttribute("aria-expanded", true);
    window.addEventListener("resize", this.onResize);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus) {
    if (!elementToFocus) return;
    super.closeMenuDrawer(event, elementToFocus);
    this.header.classList.remove("menu-open");
    window.removeEventListener("resize", this.onResize);
  }

  onResize = () => {
    this.header &&
      document.documentElement.style.setProperty(
        "--header-bottom-position",
        `${parseInt(
          this.header.getBoundingClientRect().bottom - this.borderOffset
        )}px`
      );
    document.documentElement.style.setProperty(
      "--viewport-height",
      `${window.innerHeight}px`
    );
  };
}

customElements.define("header-drawer", HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener(
      "click",
      this.hide.bind(this, false)
    );
    this.addEventListener("keyup", (event) => {
      if (event.code.toUpperCase() === "ESCAPE") this.hide();
    });
    if (this.classList.contains("media-modal")) {
      this.addEventListener("pointerup", (event) => {
        if (
          event.pointerType === "mouse" &&
          !event.target.closest("deferred-media, product-model")
        )
          this.hide();
      });
    } else {
      this.addEventListener("click", (event) => {
        if (event.target === this) this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector(".template-popup");
    document.body.classList.add("overflow-hidden");
    this.setAttribute("open", "");
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove("overflow-hidden");
    document.body.dispatchEvent(new CustomEvent("modalClosed"));
    this.removeAttribute("open");
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define("modal-dialog", ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector("button");

    if (!button) return;
    button.addEventListener("click", () => {
      const modal = document.querySelector(this.getAttribute("data-modal"));
      if (modal) modal.show(button);
    });
  }
}
customElements.define("modal-opener", ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener("click", this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute("loaded")) {
      const content = document.createElement("div");
      content.appendChild(
        this.querySelector("template").content.firstElementChild.cloneNode(true)
      );

      this.setAttribute("loaded", true);
      const deferredElement = this.appendChild(
        content.querySelector("video, model-viewer, iframe")
      );
      if (focus) deferredElement.focus();
      if (
        deferredElement.nodeName == "VIDEO" &&
        deferredElement.getAttribute("autoplay")
      ) {
        // force autoplay for safari
        deferredElement.play();
      }
    }
  }
}

customElements.define("deferred-media", DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.enableSliderLooping = false;
    this.currentPageElement = this.querySelector(".slider-counter--current");
    this.pageTotalElement = this.querySelector(".slider-counter--total");
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    if (!this.slider || !this.nextButton) return;

    this.initPages();
    const resizeObserver = new ResizeObserver((entries) => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener("scroll", this.update.bind(this));
    this.prevButton.addEventListener("click", this.onButtonClick.bind(this));
    this.nextButton.addEventListener("click", this.onButtonClick.bind(this));
  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter(
      (element) => element.clientWidth > 0
    );
    if (this.sliderItemsToShow.length < 2) return;
    this.sliderItemOffset =
      this.sliderItemsToShow[1].offsetLeft -
      this.sliderItemsToShow[0].offsetLeft;
    this.slidesPerPage = Math.floor(
      (this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) /
        this.sliderItemOffset
    );
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }

  update() {
    // Temporarily prevents unneeded updates resulting from variant changes
    // This should be refactored as part of https://github.com/Shopify/dawn/issues/2057
    if (!this.slider || !this.nextButton) return;

    const previousPage = this.currentPage;
    this.currentPage =
      Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }

    if (this.currentPage != previousPage) {
      this.dispatchEvent(
        new CustomEvent("slideChanged", {
          detail: {
            currentPage: this.currentPage,
            currentElement: this.sliderItemsToShow[this.currentPage - 1],
          },
        })
      );
    }

    if (this.enableSliderLooping) return;

    if (
      this.isSlideVisible(this.sliderItemsToShow[0]) &&
      this.slider.scrollLeft === 0
    ) {
      this.prevButton.setAttribute("disabled", "disabled");
    } else {
      this.prevButton.removeAttribute("disabled");
    }

    if (
      this.isSlideVisible(
        this.sliderItemsToShow[this.sliderItemsToShow.length - 1]
      )
    ) {
      this.nextButton.setAttribute("disabled", "disabled");
    } else {
      this.nextButton.removeAttribute("disabled");
    }
  }

  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide =
      this.slider.clientWidth + this.slider.scrollLeft - offset;
    return (
      element.offsetLeft + element.clientWidth <= lastVisibleSlide &&
      element.offsetLeft >= this.slider.scrollLeft
    );
  }

  onButtonClick(event) {
    event.preventDefault();
    const step = event.currentTarget.dataset.step || 1;
    this.slideScrollPosition =
      event.currentTarget.name === "next"
        ? this.slider.scrollLeft + step * this.sliderItemOffset
        : this.slider.scrollLeft - step * this.sliderItemOffset;
    this.slider.scrollTo({
      left: this.slideScrollPosition,
    });
  }
}

customElements.define("slider-component", SliderComponent);

class SlideshowComponent extends SliderComponent {
  constructor() {
    super();
    this.sliderControlWrapper = this.querySelector(".slider-buttons");
    this.enableSliderLooping = true;

    if (!this.sliderControlWrapper) return;

    this.sliderFirstItemNode = this.slider.querySelector(".slideshow__slide");
    if (this.sliderItemsToShow.length > 0) this.currentPage = 1;

    this.sliderControlLinksArray = Array.from(
      this.sliderControlWrapper.querySelectorAll(".slider-counter__link")
    );
    this.sliderControlLinksArray.forEach((link) =>
      link.addEventListener("click", this.linkToSlide.bind(this))
    );
    this.slider.addEventListener("scroll", this.setSlideVisibility.bind(this));
    this.setSlideVisibility();

    if (this.slider.getAttribute("data-autoplay") === "true")
      this.setAutoPlay();
  }

  setAutoPlay() {
    this.sliderAutoplayButton = this.querySelector(".slideshow__autoplay");
    this.autoplaySpeed = this.slider.dataset.speed * 1000;

    this.sliderAutoplayButton.addEventListener(
      "click",
      this.autoPlayToggle.bind(this)
    );
    this.addEventListener("mouseover", this.focusInHandling.bind(this));
    this.addEventListener("mouseleave", this.focusOutHandling.bind(this));
    this.addEventListener("focusin", this.focusInHandling.bind(this));
    this.addEventListener("focusout", this.focusOutHandling.bind(this));

    this.play();
    this.autoplayButtonIsSetToPlay = true;
  }

  onButtonClick(event) {
    super.onButtonClick(event);
    const isFirstSlide = this.currentPage === 1;
    const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

    if (!isFirstSlide && !isLastSlide) return;

    if (isFirstSlide && event.currentTarget.name === "previous") {
      this.slideScrollPosition =
        this.slider.scrollLeft +
        this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
    } else if (isLastSlide && event.currentTarget.name === "next") {
      this.slideScrollPosition = 0;
    }
    this.slider.scrollTo({
      left: this.slideScrollPosition,
    });
  }

  update() {
    super.update();
    this.sliderControlButtons = this.querySelectorAll(".slider-counter__link");
    this.prevButton.removeAttribute("disabled");
    if (!this.sliderControlButtons.length) return;

    this.sliderControlButtons.forEach((link) => {
      link.classList.remove("slider-counter__link--active");
      link.removeAttribute("aria-current");
    });
    this.sliderControlButtons[this.currentPage - 1].classList.add(
      "slider-counter__link--active"
    );
    this.sliderControlButtons[this.currentPage - 1].setAttribute(
      "aria-current",
      true
    );
  }

  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
    this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
    this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
  }

  focusOutHandling(event) {
    const focusedOnAutoplayButton =
      event.target === this.sliderAutoplayButton ||
      this.sliderAutoplayButton.contains(event.target);
    if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
    this.play();
  }

  focusInHandling(event) {
    const focusedOnAutoplayButton =
      event.target === this.sliderAutoplayButton ||
      this.sliderAutoplayButton.contains(event.target);
    if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
      this.play();
    } else if (this.autoplayButtonIsSetToPlay) {
      this.pause();
    }
  }

  play() {
    this.slider.setAttribute("aria-live", "off");
    clearInterval(this.autoplay);
    this.autoplay = setInterval(
      this.autoRotateSlides.bind(this),
      this.autoplaySpeed
    );
  }

  pause() {
    this.slider.setAttribute("aria-live", "polite");
    clearInterval(this.autoplay);
  }

  togglePlayButtonState(pauseAutoplay) {
    if (pauseAutoplay) {
      this.sliderAutoplayButton.classList.add("slideshow__autoplay--paused");
      this.sliderAutoplayButton.setAttribute(
        "aria-label",
        window.accessibilityStrings.playSlideshow
      );
    } else {
      this.sliderAutoplayButton.classList.remove("slideshow__autoplay--paused");
      this.sliderAutoplayButton.setAttribute(
        "aria-label",
        window.accessibilityStrings.pauseSlideshow
      );
    }
  }

  autoRotateSlides() {
    const slideScrollPosition =
      this.currentPage === this.sliderItems.length
        ? 0
        : this.slider.scrollLeft +
          this.slider.querySelector(".slideshow__slide").clientWidth;
    this.slider.scrollTo({
      left: slideScrollPosition,
    });
  }

  setSlideVisibility() {
    this.sliderItemsToShow.forEach((item, index) => {
      const linkElements = item.querySelectorAll("a");
      if (index === this.currentPage - 1) {
        if (linkElements.length)
          linkElements.forEach((button) => {
            button.removeAttribute("tabindex");
          });
        item.setAttribute("aria-hidden", "false");
        item.removeAttribute("tabindex");
      } else {
        if (linkElements.length)
          linkElements.forEach((button) => {
            button.setAttribute("tabindex", "-1");
          });
        item.setAttribute("aria-hidden", "true");
        item.setAttribute("tabindex", "-1");
      }
    });
  }

  linkToSlide(event) {
    event.preventDefault();
    const slideScrollPosition =
      this.slider.scrollLeft +
      this.sliderFirstItemNode.clientWidth *
        (this.sliderControlLinksArray.indexOf(event.currentTarget) +
          1 -
          this.currentPage);
    this.slider.scrollTo({
      left: slideScrollPosition,
    });
  }
}

customElements.define("slideshow-component", SlideshowComponent);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener("change", this.onVariantChange);
    this.addEventListener("click", this.onInputClick);
  }

  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, "", false);
    this.updatePickupAvailability();
    this.removeErrorMessage();
    this.updateVariantStatuses();

    if (!this.currentVariant) {
      this.toggleAddButton(true, "", true);
      this.setUnavailable();
    } else {
      this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
      this.updateShareUrl();
    }
    window.dispatchEvent(new CustomEvent('variant:change', { detail: { variant: this.currentVariant } }));
  }

  // On variant click
  onInputClick(event) {
    if (
      event.target.matches(
        'input[type="radio"], input[type="checkbox"], option'
      )
    ) {
      this.updateURL();
    }
  }

  updateOptions() {
    this.options = Array.from(
      this.querySelectorAll("select"),
      (select) => select.value
    );
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options
        .map((option, index) => {
          return this.options[index] === option;
        })
        .includes(false);
    });
  }

  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;

    const mediaGalleries = document.querySelectorAll(
      `[id^="MediaGallery-${this.dataset.section}"]`
    );
    mediaGalleries.forEach((mediaGallery) =>
      mediaGallery.setActiveMedia(
        `${this.dataset.section}-${this.currentVariant.featured_media.id}`,
        true
      )
    );

    const modalContent = document.querySelector(
      `#ProductModal-${this.dataset.section} .product-media-modal__content`
    );
    if (!modalContent) return;
    const newMediaModal = modalContent.querySelector(
      `[data-media-id="${this.currentVariant.featured_media.id}"]`
    );
    modalContent.prepend(newMediaModal);
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === "false") return;
    window.history.replaceState(
      {},
      "",
      `${this.dataset.url}?variant=${this.currentVariant.id}`
    );
  }

  // updateURL() {
  //   const selectedOptions = this.gatherSelectedOptions();
  //   const newQueryString = selectedOptions.map(option => `${option.name}=${option.value}`).join('&');
  //   history.pushState({}, '', `${window.location.pathname}?${newQueryString}`);
  // }

  gatherSelectedOptions() {
    const inputs = Array.from(
      this.querySelectorAll("input:checked, option:selected")
    );
    return inputs.map((input) => ({
      name: input.name,
      value: input.value,
    }));
  }

  updateShareUrl() {
    const shareButton = document.getElementById(
      `Share-${this.dataset.section}`
    );
    if (!shareButton || !shareButton.updateUrl) return;
    shareButton.updateUrl(
      `${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`
    );
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(
      `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`
    );
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event("change", { bubbles: true }));
    });
  }

  updateVariantStatuses() {
    const selectedOptionOneVariants = this.variantData.filter(
      (variant) => this.querySelector(":checked").value === variant.option1
    );
    const inputWrappers = [...this.querySelectorAll(".product-form__input")];
    inputWrappers.forEach((option, index) => {
      if (index === 0) return;
      const optionInputs = [
        ...option.querySelectorAll('input[type="radio"], option'),
      ];
      const previousOptionSelected =
        inputWrappers[index - 1].querySelector(":checked").value;
      const availableOptionInputsValue = selectedOptionOneVariants
        .filter(
          (variant) =>
            variant.available &&
            variant[`option${index}`] === previousOptionSelected
        )
        .map((variantOption) => variantOption[`option${index + 1}`]);
      this.setInputAvailability(optionInputs, availableOptionInputsValue);
    });
    let variant_id = selectedOptionOneVariants[0].id;

    // Update the option
    let option_name = document
      .querySelector(`.variant-list[data-variant-id="` + variant_id + `"]`)
      .getAttribute("data-variant-option-name");
    let number_options = document
      .querySelector(`.variant-list[data-variant-id="` + variant_id + `"]`)
      .getAttribute("data-variant-option-total");
    if (number_options == "2") {
      variant_id = this.currentVariant.id;
      selectedOptionOneVariants.forEach((variant) => {
        if (variant.id == variant_id) {
          let option1 = variant.option1;
          let option2 = variant.option2;
          document.querySelector(".current_option_name_Colour").textContent = option1;
          document.querySelector(".current_option_name_Size").textContent = option2;
        }
      });
    } else {
      document.querySelector(".current_option_name").textContent = option_name;
    }

    // Update Attributes
    const consignmentDateElement = document.querySelector(`.variant-list[data-variant-id="` + variant_id + `"]`);
    let consignmentDate = consignmentDateElement?.getAttribute("data-variant-consignment-date") || null;

    if (consignmentDate) {
      consignmentDate = consignmentDate.replace(/,\s*\d{4}/, "");
      document.querySelector(".consignment-date").innerHTML = consignmentDate;
    }

    // Update Price
    let bn_price = document
      .querySelector(`.variant-list[data-variant-id="` + variant_id + `"]`)
      .getAttribute("data-variant-bn-price");
    let poPrice = document
      .querySelector(`.variant-list[data-variant-id="` + variant_id + `"]`)
      .getAttribute("data-variant-po-price");
    let compare_price = document
      .querySelector(`.variant-list[data-variant-id="` + variant_id + `"]`)
      .getAttribute("data-variant-compare-price");
    let po_price = document
      .querySelector(`.variant-list[data-variant-id="` + variant_id + `"]`)
      .getAttribute("data-variant-po-price");
    let storewide = document
      .querySelector(`.variant-list[data-variant-id="` + variant_id + `"]`)
      .getAttribute("data-variant-storewide");
    let clearance = document
      .querySelector(`.variant-list[data-variant-id="` + variant_id + `"]`)
      .getAttribute("data-variant-clearance");
    let bn_percent = document
      .querySelector(`.variant-list[data-variant-id="` + variant_id + `"]`)
      .getAttribute("data-variant-percent");
    let po_percent = document
      .querySelector(`.variant-list[data-variant-id="` + variant_id + `"]`)
      .getAttribute("data-variant-po-disount");


    document
      .querySelector("span.badge.price__badge-sale")
      .setAttribute("storewide_sale", storewide);
    document
      .querySelector(".under-title-price-box .price.price--large")
      .setAttribute("clearance", clearance);

    if (document.querySelector(".purchase-type-item-pre-order.selected")) {
      // PO Selected

      // Update Attributes
      document.querySelector("input.input-consignment-date").value = consignmentDate;


      let promo_box_savings_percent = document
        .querySelector(`.variant-list[data-variant-id="` + variant_id + `"]`)
        .getAttribute("data-variant-savings-percent");
      let promo_box_discount = document
        .querySelector(`.variant-list[data-variant-id="` + variant_id + `"]`)
        .getAttribute("data-variant-bn-disount");
      let promo_box_storewide = document
        .querySelector(`.variant-list[data-variant-id="` + variant_id + `"]`)
        .getAttribute("data-variant-storewide");
      if (
        promo_box_savings_percent != "" &&
        document.querySelector("span.check_savings_percent") !== null
      ) {
        document.querySelector("span.check_savings_percent").innerHTML =
          promo_box_savings_percent;
      }
      if (
        promo_box_discount != "" &&
        document.querySelector("span.check_discount") !== null
      ) {
        document.querySelector("span.check_discount").innerHTML =
          promo_box_discount;
      }
      if (promo_box_storewide != "") {
        if (promo_box_storewide == "true") {
          if (document.querySelector(".pdp-promo-box.standard") !== null) {
            document.querySelector(".pdp-promo-box.standard").style.display =
              "block";
          }
        } else {
          if (document.querySelector(".pdp-promo-box.standard") !== null) {
            document.querySelector(".pdp-promo-box.standard").style.display =
              "none";
          }
        }
      }
    }

    // Update Additional information
    let additional_information = document
      .querySelector(`.variant-list[data-variant-id="` + variant_id + `"]`)
      .getAttribute("data-additional-info");
    let variant_name = document
      .querySelector(`.variant-list[data-variant-id="` + variant_id + `"]`)
      .getAttribute("data-variant-name");
    if (additional_information != "") {
      document.querySelector("#additional-info").innerHTML =
        additional_information;
      document.querySelector("#variant-name").innerHTML = variant_name;
      document.getElementById("additional-info-trigger").style.display =
        "block";
    } else {
      document.getElementById("additional-info-trigger").style.display = "none";
    }

        // Update multibox_shipping
        let multibox_shipping = document
        .querySelector(`.variant-list[data-variant-id="` + variant_id + `"]`)
        .getAttribute("data-variant-multibox-shipping");
      document.querySelector("#multibox_shipping_dimensions-box").innerHTML =
        multibox_shipping;
      if (multibox_shipping !== "") {
        document.querySelector(".multibox_shipping_dimensions").style.display =
          "block";
        document.querySelector("#prod_table_dimmesions").style.display = "none";
      } else {
        document.querySelector(".multibox_shipping_dimensions").style.display =
          "none";
        document.querySelector("#prod_table_dimmesions").style.display = "table";
      }

      // Update Dimensions
      let dimensions = document
  .querySelector(`.variant-list[data-variant-id="` + variant_id + `"]`)
  .getAttribute("data-product-dimensions");

// Convert meters to centimeters
dimensions = dimensions.replace(/(<td>(Width|Depth|Height|Box Width|Box Depth|Box Height|)<\/td><td>)(\d+(?:\.\d+)?)(<\/td>)/g, (match, prefix, dimension, number, suffix) =>
  `${prefix}${(parseFloat(number) * 100).toFixed(0)} cm${suffix}`
);

// Ensure weight is displayed in kilograms, handling cases where .0 might not be present
dimensions = dimensions.replace(/(<td>Weight<\/td><td>)(\d+)(\.0)?(<\/td>)/, function(match, p1, p2, p3, p4) {
  return p1 + p2 + " kg" + p4;
});


      document.querySelector("#product-dimensions").innerHTML = dimensions;

      // Update Specifications Image
      let specifications_image = document
        .querySelector(`.variant-list[data-variant-id="` + variant_id + `"]`)
        .getAttribute("data-specifications-image");
      document.querySelector("#specifications-image").innerHTML =
        specifications_image;

      // Update Materials
      let materials = document
        .querySelector(`.variant-list[data-variant-id="` + variant_id + `"]`)
        .getAttribute("data-product-materials");
      document.querySelector("#product-materials").innerHTML = materials;
      if (materials != "" && materials != " ") {
        document.querySelector("#prod-materialsTable").style.display = "flex";
      } else {
        document.querySelector("#prod-materialsTable").style.display = "none";
      }

      // Update Box Information
      let box_information = document
      .querySelector(`.variant-list[data-variant-id="` + variant_id + `"]`)
      .getAttribute("data-box-info");

      box_information = box_information.replace(/(\d+(\.\d+)?)\s*m/g, function(match, number) {
        return (parseFloat(number) * 100).toFixed(0) + " cm";
      });

      document.querySelector("#product-box-info").innerHTML = box_information;

    // Update SKU
    let sku = document
      .querySelector(`.variant-list[data-variant-id="` + variant_id + `"]`)
      .getAttribute("data-product-sku");
    let inventory_quantity = document
      .querySelector(`.variant-list[data-variant-id="` + variant_id + `"]`)
      .getAttribute("data-product-inventory-quantity");
    let inventory_days = document
      .querySelector(`.variant-list[data-variant-id="` + variant_id + `"]`)
      .getAttribute("data-product-inventory-days");

    let terminal = document.querySelector(`.variant-list[data-variant-id="` + variant_id + `"]`).getAttribute("data-variant-terminal");
    // Update Other Info
    let other_info = document
      .querySelector(`.variant-list[data-variant-id="` + variant_id + `"]`)
      .getAttribute("data-other-info");
    other_info = other_info.replace(/<tr>.*?<td>SKU.*?<\/td>.*?<\/tr>/gi, "");

    // Combine both updates into one HTML string, with SKU first
    let combinedHTML = `
      <table>
        <tr>
          <td>SKU</td>
          <td>${sku}
            <span class="other-info-note">
              <span class="variant_inventory_quantity" style="color:grey; font-size:0.6em; margin-right: -4px;">
                ${inventory_quantity}</span>
              <span class="variant_inventory_days" style="color:grey; font-size:0.6em;">
                (${inventory_days})
              </span>
              <span class="variant_inventory_days" style="color:grey; font-size:0.6em;">
              ${terminal === "true" ? "T" : ""}
              </span>
            </span>
          </td>
        </tr>
      </table>
      <div>${other_info}</div>
    `;

    // Set the innerHTML of the product-other-info element to the combined HTML
    document.querySelector("#product-other-info").innerHTML = combinedHTML;


      // Update FAQ
      // let product_faq = document.querySelector(`.variant-list[data-variant-id="` + variant_id + `"]`).getAttribute("data-product-faq");
      // let faqTab = document.getElementById("faq-tab");
      // document.querySelector("#faq").innerHTML = product_faq;
      // !product_faq ? faqTab.style.display = "none" : faqTab.style.display = "block";

  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach((input) => {
      if (listOfAvailableOptions.includes(input.getAttribute("value"))) {
        input.innerText = input.getAttribute("value");
      } else {
        input.innerText = window.variantStrings.unavailable_with_option.replace(
          "[value]",
          input.getAttribute("value")
        );
      }
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector("pickup-availability");
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute("available");
      pickUpAvailability.innerHTML = "";
    }
  }

  removeErrorMessage() {
    const section = this.closest("section");
    if (!section) return;

    const productForm = section.querySelector("product-form");
    if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo() {
    const requestedVariantId = this.currentVariant.id;
    const sectionId = this.dataset.originalSection
      ? this.dataset.originalSection
      : this.dataset.section;

    fetch(
      `${this.dataset.url}?variant=${requestedVariantId}&section_id=${
        this.dataset.originalSection
          ? this.dataset.originalSection
          : this.dataset.section
      }`
    )
      .then((response) => response.text())
      .then((responseText) => {
        // prevent unnecessary ui changes from abandoned selections
        if (this.currentVariant.id !== requestedVariantId) return;

        const html = new DOMParser().parseFromString(responseText, "text/html");
        //const destination = document.getElementById(`price-${this.dataset.section}`);
        //const source = html.getElementById(`price-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`);
        const skuSource = html.getElementById(
          `Sku-${
            this.dataset.originalSection
              ? this.dataset.originalSection
              : this.dataset.section
          }`
        );
        const skuDestination = document.getElementById(
          `Sku-${this.dataset.section}`
        );
        const inventorySource = html.getElementById(
          `Inventory-${
            this.dataset.originalSection
              ? this.dataset.originalSection
              : this.dataset.section
          }`
        );
        const inventoryDestination = document.getElementById(
          `Inventory-${this.dataset.section}`
        );

        //if (source && destination) destination.innerHTML = source.innerHTML;
        if (inventorySource && inventoryDestination)
          inventoryDestination.innerHTML = inventorySource.innerHTML;
        if (skuSource && skuDestination) {
          skuDestination.innerHTML = skuSource.innerHTML;
          skuDestination.classList.toggle(
            "visibility-hidden",
            skuSource.classList.contains("visibility-hidden")
          );
        }

        //const price = document.getElementById(`price-${this.dataset.section}`);

        //if (price) price.classList.remove('visibility-hidden');

        if (inventoryDestination)
          inventoryDestination.classList.toggle(
            "visibility-hidden",
            inventorySource.innerText === ""
          );

        const addButtonUpdated = html.getElementById(
          `ProductSubmitButton-${sectionId}`
        );
        this.toggleAddButton(
          addButtonUpdated ? addButtonUpdated.hasAttribute("disabled") : true,
          window.variantStrings.soldOut
        );

        publish(PUB_SUB_EVENTS.variantChange, {
          data: {
            sectionId,
            html,
            variant: this.currentVariant,
          },
        });
      });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(
      `product-form-${this.dataset.section}`
    );
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');
    if (!addButton) return;

    if (disable) {
      addButton.setAttribute("disabled", "disabled");
      if (text) addButtonText.textContent = text;
    } else {
      addButton.removeAttribute("disabled");
      addButtonText.textContent = window.variantStrings.addToCart;
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const button = document.getElementById(
      `product-form-${this.dataset.section}`
    );
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    const inventory = document.getElementById(
      `Inventory-${this.dataset.section}`
    );
    const sku = document.getElementById(`Sku-${this.dataset.section}`);

    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add("visibility-hidden");
    if (inventory) inventory.classList.add("visibility-hidden");
    if (sku) sku.classList.add("visibility-hidden");
  }

  getVariantData() {
    this.variantData =
      this.variantData ||
      JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}

customElements.define("variant-selects", VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach((input) => {
      if (listOfAvailableOptions.includes(input.getAttribute("value"))) {
        input.classList.remove("disabled");
      } else {
        input.classList.add("disabled");
      }
    });
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll("fieldset"));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll("input")).find(
        (radio) => radio.checked
      ).value;
    });
  }
}

customElements.define("variant-radios", VariantRadios);

class ProductRecommendations extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      fetch(this.dataset.url)
        .then((response) => response.text())
        .then((text) => {
          const html = document.createElement("div");
          html.innerHTML = text;
          const recommendations = html.querySelector("product-recommendations");

          if (recommendations && recommendations.innerHTML.trim().length) {
            this.innerHTML = recommendations.innerHTML;
          }

          if (
            !this.querySelector("slideshow-component") &&
            this.classList.contains("complementary-products")
          ) {
            this.remove();
          }

          if (html.querySelector(".grid__item")) {
            this.classList.add("product-recommendations--loaded");
          }
        })
        .catch((e) => {
          // console.error(e);
        });
    };

    new IntersectionObserver(handleIntersection.bind(this), {
      rootMargin: "0px 0px 400px 0px",
    }).observe(this);
  }
}

customElements.define("product-recommendations", ProductRecommendations);

function openModal() {
  document.getElementById("modalCappedshipping").style.display = "flex";
  document.body.classList.add("moda-open");
}
function closeModal() {
  document.getElementById("modalCappedshipping").style.display = "none";
  document.body.classList.remove("moda-open");
}
window.onclick = function (event) {
  var modal = document.getElementById("modalCappedshipping");
  if (event.target === modal) {
    closeModal();
  }
};

function openModalBN() {
  document.getElementById("modalCappedshippingBN").style.display = "flex";
  document.body.classList.add("moda-open");
}
function closeModalBN() {
  document.getElementById("modalCappedshippingBN").style.display = "none";
  document.body.classList.remove("moda-open");
}
window.onclick = function (event) {
  var modal = document.getElementById("modalCappedshippingBN");
  if (event.target === modal) {
    closeModal();
  }
};

function openModalIN() {
  document.getElementById("insiderModal").style.display = "flex";
  document.body.classList.add("moda-open");
}
function closeModalIN() {
  document.getElementById("insiderModal").style.display = "none";
  document.body.classList.remove("moda-open");
}


$(function () {
  loadPageInCappedShippingModal = function (elm) {
    var loadPageInCappedShippingModalUrl = $("#modalCappedshipping").attr(
      "data-source"
    );
    if (loadPageInCappedShippingModalUrl != "") {
      $(elm).addClass("loading");
      $.ajax({
        type: "GET",
        url: loadPageInCappedShippingModalUrl,
        data: {},
        success: function (data) {
          var newData = $(data).find(".MainContentBox").html();
          $(elm).removeClass("loading");
          $("#modalCappedshippingHolder").html(newData);
          openModal();
        },
      });
    }
  };
});

$(function () {
  loadPageInCappedShippingModalBN = function (elm) {
    var loadPageInCappedShippingModalUrlBN = $("#modalCappedshippingBN").attr(
      "data-source"
    );
    if (loadPageInCappedShippingModalUrlBN != "") {
      $(elm).addClass("loading");
      $.ajax({
        type: "GET",
        url: loadPageInCappedShippingModalUrlBN,
        data: {},
        success: function (data) {
          var newData = $(data).find(".MainContentBox").html();
          $(elm).removeClass("loading");
          $("#modalCappedshippingHolderBN").html(newData);
          openModalBN();
        },
      });
    }
  };
});

function openModalShipping() {
  document.getElementById("modalShipping").style.display = "flex";
  document.body.classList.add("moda-open");
}
function closeModalShipping() {
  document.getElementById("modalShipping").style.display = "none";
  document.body.classList.remove("moda-open");
}
window.onclick = function (event) {
  var modal_shipping = document.getElementById("modalShipping");
  if (event.target === modal_shipping) {
    closeModalShipping();
  }
};



$(function () {
  loadInsiderModal = function (elm) {
    var loadInsiderModalUrl = $("#insiderModal").attr(
      "data-source"
    );
    if (loadInsiderModalUrl != "") {
      $(elm).addClass("loading");
      $.ajax({
        type: "GET",
        url: loadInsiderModalUrl,
        data: {},
        success: function (data) {
          var newData = $(data).find(".MainContentBox").html();
          $(elm).removeClass("loading");
          $("#modalCappedshippingHolderIN").html(newData);
          openModalIN();
        },
      });
    }
  };
});

function openModalShipping() {
  document.getElementById("modalShipping").style.display = "flex";
  document.body.classList.add("moda-open");
}
function closeModalShipping() {
  document.getElementById("modalShipping").style.display = "none";
  document.body.classList.remove("moda-open");
}
window.onclick = function (event) {
  var modal_shipping = document.getElementById("modalShipping");
  if (event.target === modal_shipping) {
    closeModalShipping();
  }
};


$(function () {
  loadPageInShippingModal = function (elm) {
    var loadPageInShippingModalUrl = $("#modalShipping").attr("data-source");
    if (loadPageInShippingModalUrl != "") {
      $(elm).addClass("loading");
      $.ajax({
        type: "GET",
        url: loadPageInShippingModalUrl,
        data: {},
        success: function (data) {
          var newData = $(data).find(".MainContentBox").html();
          $(elm).removeClass("loading");
          $("#modalShippingHolder").html(newData);
          openModalShipping();
        },
      });
    }
  };
});

function openModalPromoBox() {
  document.getElementById("modalPromoBox").style.display = "flex";
  document.body.classList.add("moda-open");
}
function closeModalPromoBox() {
  document.getElementById("modalPromoBox").style.display = "none";
  document.body.classList.remove("moda-open");
}
window.onclick = function (event) {
  var modal_PromoBox = document.getElementById("modalPromoBox");
  var modal = document.getElementById("modalCappedshipping");
  var modal_shipping = document.getElementById("modalShipping");
  if (event.target === modal_PromoBox) {
    closeModalPromoBox();
  }
  if (event.target === modal) {
    closeModal();
  }
  if (event.target === modal_shipping) {
    closeModalShipping();
  }
};

$(function () {
  loadPageInModal = function (elm) {
    var loadPageInModalUrl = $(elm).attr("data-source");
    if (loadPageInModalUrl != "") {
      $(elm).addClass("loading");
      $.ajax({
        type: "GET",
        url: loadPageInModalUrl,
        data: {},
        success: function (data) {
          var newData = $(data).find(".MainContentBox").html();
          $(elm).removeClass("loading");
          $("#modalPromoBoxHolder").html(newData);
          openModalPromoBox();
        },
      });
    }
  };
});

// Cylindo BTNs

// Helper function to wait for the element to be present in the DOM
function waitForElm(selector) {
  return new Promise(function (resolve) {
    var intervalId = setInterval(function () {
      var element = document.querySelector(selector);
      if (element) {
        clearInterval(intervalId);
        resolve(element);
      }
    }, 100);
  });
}

document.addEventListener("DOMContentLoaded", function () {
  var cylindo360 = document.getElementById("cylindo_360");
  var cylindoThumb = document.querySelectorAll(".cylindo-thumb");
  var smallGalleryLinks = document.querySelectorAll(
    ".thumbnail-list li:not(.cylindo-thumb)"
  );

  var cylindoRoom = document.getElementById("cylindo_room");


  if (cylindoRoom) {
    cylindoRoom.addEventListener("click", function () {
      document.getElementById("cylindo-viewer-wrapper").style.display = "block";
      document.body.classList.remove("zoomContainer-hide");

      var productSingleImg = document.querySelector(".product-single-img");
      if (productSingleImg) {
        productSingleImg.style.display = "none";
      }

      var videoElements = document.querySelectorAll(
        ".tt-product-single-img .mediaholder .pt-product-media-internal video"
      );
      videoElements.forEach(function (video) {
        video.pause();
      });

      document
        .querySelector("#cylindo-viewer-wrapper cylindo-viewer")
        ?.shadowRoot?.querySelector('button[part="fab view-in-ar"]')
        .click();
    });
  }

  if (cylindo360) {
    cylindo360.addEventListener("click", function () {
      document.getElementById("cylindo-viewer-wrapper").style.display = "block";
      document.body.classList.remove("zoomContainer-hide");

      document
        .querySelector("#cylindo-viewer-wrapper cylindo-viewer")
        ?.shadowRoot?.querySelector("cylindo-ar")
        ?.shadowRoot?.querySelector('button[part="fab qr-fab"]')
        .click();

      var productSingleImg = document.querySelector(".product-single-img");
      if (productSingleImg) {
        productSingleImg.style.display = "none";
      }

      var videoElements = document.querySelectorAll(
        ".tt-product-single-img .mediaholder .pt-product-media-internal video"
      );
      videoElements.forEach(function (video) {
        video.pause();
      });

      if ($(".left-right-door-feature").length > 0) {
        document.getElementsByClassName(
          "left-right-door-feature"
        )[0].style.display = "block";
      }

      if ($(".left-right-door-text").length > 0) {
        document.getElementsByClassName(
          "left-right-door-text"
        )[0].style.display = "none";
      }
    });
  }

  /*if (cylindoThumb) {
        cylindoThumb.addEventListener("click", function() {
            document.getElementById("cylindo-viewer-wrapper").style.display = "block";
            document.body.classList.remove("zoomContainer-hide");

            var productSingleImg = document.querySelector(".product-single-img");
            if (productSingleImg) {
                productSingleImg.style.display = "none";
            }

            var videoElements = document.querySelectorAll(".tt-product-single-img .mediaholder .pt-product-media-internal video");
            videoElements.forEach(function(video) {
                video.pause();
            });

            if ( $(".left-right-door-feature").length > 0 ) {
    			document.getElementsByClassName("left-right-door-feature")[0].style.display = "block";
    		}

            if ( $(".left-right-door-text").length > 0 ) {
    			document.getElementsByClassName("left-right-door-text")[0].style.display = "none";
    		}
        });
    }*/

  if (smallGalleryLinks) {
    smallGalleryLinks.forEach(function (link) {
      link.addEventListener("click", function () {
        document.getElementById("cylindo-viewer-wrapper").style.display =
          "none";
        document.body.classList.remove("zoomContainer-hide");

        var productSingleImg = document.querySelector(".tt-product-single-img");
        if (productSingleImg) {
          productSingleImg.style.display = "block";
        }

        var videoElements = document.querySelectorAll(
          ".tt-product-single-img .mediaholder .pt-product-media-internal video"
        );
        videoElements.forEach(function (video) {
          video.pause();
        });

        if ($(".left-right-door-feature").length > 0) {
          document.getElementsByClassName(
            "left-right-door-feature"
          )[0].style.display = "none";
        }

        if ($(".left-right-door-text").length > 0) {
          document.getElementsByClassName(
            "left-right-door-text"
          )[0].style.display = "block";
        }
      });
    });
  }
});
// REFACTORED WAITING FOR TESTING BEFORE DELETE
// $(document).ready(function () {
//   $(".grid__item .swatch-selector").hover(function () {
//     var dataId = $(this).data("id");
//     var $cardVariantList = $(this)
//       .closest(".grid__item")
//       .find(".card-variant-list[data-variant-id='" + dataId + "']");
//     var variantPrice = $cardVariantList.data("variant-price");
//     var variantPricePo = $cardVariantList.data("variant-price-only");
//     var variantSave = $cardVariantList.data("variant-save");
//     var variantBadge = $cardVariantList.data("sale-badge");
//     var variantPriceDiff = $cardVariantList.data("price-diff");

//     var variantImage = $(this).attr("data-img");
//     $(this)
//       .parents(".grid__item")
//       .find(".thumb-alt-img")
//       .attr("src", variantImage);
//     $(this).parents(".grid__item").find(".thumb-alt-img").removeAttr("srcset");

//     $(this).closest(".grid__item").find(".pd-price").html(variantPrice);
//     $(this).closest(".grid__item").find(".save-price").html(variantSave);
//     if (variantBadge != "") {
//       $(this).closest(".grid__item").find(".price__badge-sale").show();
//       $(this)
//         .closest(".grid__item")
//         .find(".price__badge-sale")
//         .html(variantBadge);
//     } else {
//       $(this).closest(".grid__item").find(".price__badge-sale").hide();
//     }

//     if (variantPriceDiff == "0") {
//       $(this).closest(".grid__item").find(".price__badge-sale").hide();
//       //$(this).closest(".grid__item").find(".save-price").hide();

//       var variantSavePO = "Save up to " + variantPricePo + " (20%)";

//       $(this).closest(".grid__item").find(".save-price").html(variantSavePO);
//       $(this).closest(".grid__item").find(".old-price").hide();
//     } else {
//       $(this).closest(".grid__item").find(".price__badge-sale").show();
//       $(this).closest(".grid__item").find(".save-price").show();
//       $(this).closest(".grid__item").find(".old-price").show();
//     }
//   });
// });

// REFACTORED CODE START DO NOT DELETE!
document.addEventListener("DOMContentLoaded", function () {
  const swatchSelectors = document.querySelectorAll(".grid__item .swatch-selector");

  swatchSelectors.forEach(function (selector) {
    selector.addEventListener("mouseenter", function () {
      const dataId = this.dataset.id;
      const cardVariantList = this.closest(".grid__item").querySelector(`.card-variant-list[data-variant-id='${dataId}']`);
      const outOfStockPriceCurrent = cardVariantList.getAttribute("data-out-of-stock-price-current");
      const outOfStockPriceHigh = cardVariantList.getAttribute("data-out-of-stock-price-high");
      const outOfStockPriceDiscount = cardVariantList.getAttribute("data-out-of-stock-price-discount");
      const variantAvailable = cardVariantList.dataset.variantAvailable;
      const variantPrice = cardVariantList.dataset.variantPrice;
      const variantPricePo = cardVariantList.dataset.variantPriceOnly;
      const variantSave = cardVariantList.dataset.variantSave;
      const variantBadge = cardVariantList.dataset.saleBadge;
      const variantPriceDiff = cardVariantList.dataset.priceDiff;

      const variantImage = this.getAttribute("data-img");
      const thumbAltImg = this.closest(".grid__item").querySelector(".thumb-alt-img");
      thumbAltImg.src = variantImage;
      thumbAltImg.removeAttribute("srcset");

      this.closest(".grid__item").querySelector(".pd-price").innerHTML = variantPrice;
      this.closest(".grid__item").querySelector(".save-price").innerHTML = variantSave;

      const priceBadgeSale = this.closest(".grid__item").querySelector(".price__badge-sale");
      if (variantBadge !== "") {
        priceBadgeSale.style.display = "inline-block";
        priceBadgeSale.innerHTML = variantBadge;
      } else {
        priceBadgeSale.style.display = "none";
      }

      if (variantPriceDiff === "0") {
        priceBadgeSale.style.display = "none";
        const variantSavePO = `Save up to ${variantPricePo} (20%)`;
        this.closest(".grid__item").querySelector(".save-price").innerHTML = variantSavePO;
        this.closest(".grid__item").querySelector(".old-price").style.display = "none";
      } else if (variantAvailable === "0" || variantAvailable < 0) {
        this.closest(".grid__item").querySelector(".pd-price").innerHTML = `${outOfStockPriceCurrent} - ${outOfStockPriceHigh}`;
        let variantSavePO = `Save up to ${outOfStockPriceDiscount} (20%)`;
        this.closest(".grid__item").querySelector(".save-price").innerHTML = variantSavePO;
        this.closest(".grid__item").querySelector(".old-price").style.display = "inline-block";
      }
      else {
        priceBadgeSale.style.display = "inline-block";
        this.closest(".grid__item").querySelector(".save-price").style.display = "inline-block";
        this.closest(".grid__item").querySelector(".old-price").style.display = "inline-block";
      }
    });
  });
});

$(document).ready(function updateOrderType() {
  setTimeout(() => {
    const buyNowChecked = document.getElementById("Option-header-buy-now").checked;
    const preOrderChecked = document.getElementById("Option-header-pre-order").checked;
    const orderTypeElement = document.getElementById("order_type");

    if (buyNowChecked) {
      orderTypeElement.textContent = "Buy Now";
    } else if (preOrderChecked) {
      orderTypeElement.textContent = "Pre-Order";
    } else {
      orderTypeElement.textContent = "";
    }

    // document.getElementById("Option-header-buy-now").addEventListener("change", updateOrderType);
    // document.getElementById("Option-header-pre-order").addEventListener("change", updateOrderType);
    // let consignmentDate = document.querySelector(`.variant-list[data-variant-id="` + variant_id + `"]`).getAttribute("data-variant-consignment-date");
    // consignmentDate = consignmentDate.replace(/,\s*\d{4}/, "");
    // document.querySelector(".consignment-date").innerHTML = consignmentDate;
    // document.querySelector("input.input-consignment-date").value = consignmentDate;
  }, 400); // Timeout set to 0 ms
});

document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll(".accordion-toggle").forEach(function (toggle) {
    toggle.addEventListener("click", function () {
      const productSection = this.closest(".product-section");
      const accordionBody = productSection.querySelector(".accordion-body");

      if (!this.classList.contains("show")) {
        this.classList.add("show");
        productSection.classList.add("show");
        accordionBody.classList.add("show");
      } else {
        this.classList.remove("show");
        productSection.classList.remove("show");
        accordionBody.classList.remove("show");
      }
    });
  });
});

function showDescription() {
  // Select the elements by their respective selectors
  const description = document.querySelector("#description");
  const accordionToggle = document.querySelector(
    "#description .accordion-toggle"
  );
  const accordionBody = document.querySelector("#description .accordion-body");

  // Add the 'show' class to each of the selected elements
  if (description) description.classList.add("show");
  if (accordionToggle) accordionToggle.classList.add("show");
  if (accordionBody) accordionBody.classList.add("show");

  // Get the element you want to scroll to
  var element = document.getElementById("description");

  // Calculate its position relative to the viewport
  var elementPosition = element.getBoundingClientRect().top;

  // Scroll to the element
  window.scrollTo({
    top: window.pageYOffset + elementPosition - 150,
    behavior: "smooth",
  });
}

function showSpecification() {
  // Select the elements by their respective selectors
  const specifications = document.querySelector("#specifications");
  const accordionToggle = document.querySelector(
    "#specifications .accordion-toggle"
  );
  const accordionBody = document.querySelector(
    "#specifications .accordion-body"
  );

  // Add the 'show' class to each of the selected elements
  if (specifications) specifications.classList.add("show");
  if (accordionToggle) accordionToggle.classList.add("show");
  if (accordionBody) accordionBody.classList.add("show");

  // Get the element you want to scroll to
  var element = document.getElementById("specifications");

  // Calculate its position relative to the viewport
  var elementPosition = element.getBoundingClientRect().top;

  // Scroll to the element
  window.scrollTo({
    top: window.pageYOffset + elementPosition - 150,
    behavior: "smooth",
  });
}

function showReviews() {
  // Select the elements by their respective selectors
  const reviews = document.querySelector("#reviews");
  const accordionToggle = document.querySelector("#reviews .accordion-toggle");
  const accordionBody = document.querySelector("#reviews .accordion-body");

  // Add the 'show' class to each of the selected elements
  if (reviews) reviews.classList.add("show");
  if (accordionToggle) accordionToggle.classList.add("show");
  if (accordionBody) accordionBody.classList.add("show");

  // Get the element you want to scroll to
  var element = document.getElementById("reviews");

  // Calculate its position relative to the viewport
  var elementPosition = element.getBoundingClientRect().top;

  // Scroll to the element
  window.scrollTo({
    top: window.pageYOffset + elementPosition - 150,
    behavior: "smooth",
  });
}

function showShipping() {
  // Select the elements by their respective selectors
  const shipping = document.querySelector("#shipping");
  const accordionToggle = document.querySelector("#shipping .accordion-toggle");
  const accordionBody = document.querySelector("#shipping .accordion-body");

  // Add the 'show' class to each of the selected elements
  if (shipping) shipping.classList.add("show");
  if (accordionToggle) accordionToggle.classList.add("show");
  if (accordionBody) accordionBody.classList.add("show");

  // Get the element you want to scroll to
  var element = document.getElementById("shipping");

  // Calculate its position relative to the viewport
  var elementPosition = element.getBoundingClientRect().top;

  // Scroll to the element
  window.scrollTo({
    top: window.pageYOffset + elementPosition - 150,
    behavior: "smooth",
  });
}

function showFaq() {
  // Select the elements by their respective selectors
  const faq = document.querySelector("#faq");
  const accordionToggle = document.querySelector("#faq .accordion-toggle");
  const accordionBody = document.querySelector("#faq .accordion-body");

  // Add the 'show' class to each of the selected elements
  if (faq) faq.classList.add("show");
  if (accordionToggle) accordionToggle.classList.add("show");
  if (accordionBody) accordionBody.classList.add("show");

  // Get the element you want to scroll to
  var element = document.getElementById("faq");

  // Calculate its position relative to the viewport
  var elementPosition = element.getBoundingClientRect().top;

  // Scroll to the element
  window.scrollTo({
    top: window.pageYOffset + elementPosition - 150,
    behavior: "smooth",
  });
}

function showRelated() {
  // Select the elements by their respective selectors
  const prod_related = document.querySelector("#prod-related");
  const accordionToggle = document.querySelector(
    "#prod-related .accordion-toggle"
  );
  const accordionBody = document.querySelector("#prod-related .accordion-body");

  // Add the 'show' class to each of the selected elements
  if (prod_related) prod_related.classList.add("show");
  if (accordionToggle) accordionToggle.classList.add("show");
  if (accordionBody) accordionBody.classList.add("show");

  // Get the element you want to scroll to
  var element = document.getElementById("prod-related");

  // Calculate its position relative to the viewport
  var elementPosition = element.getBoundingClientRect().top;

  // Scroll to the element
  window.scrollTo({
    top: window.pageYOffset + elementPosition - 150,
    behavior: "smooth",
  });
}

function accordionRelated() {
  const productSection = this.closest(".product-section");
  const accordionBody = productSection.querySelector(".accordion-body");

  if (!this.classList.contains("show")) {
    this.classList.add("show");
    productSection.classList.add("show");
    accordionBody.classList.add("show");
  } else {
    this.classList.remove("show");
    productSection.classList.remove("show");
    accordionBody.classList.remove("show");
  }
}

// let menuItem = document.querySelector(".mobile-facets__open");
// let chatItem = document.querySelector(".tawk-min-container .tawk-button-circle.tawk-button-large");
// menuItem.addEventListener("click", function() {
//   setTimeout(() => {
//     chatItem.style.display = "none";
//   }, 1000); // 1s delay
// });
